module.exports = __webpack_public_path__ + "img/carp_2kl.f8a29d25.jpg";